const getDefaultState = () => {
  return {
    users: [],
    animateursDeRegions: [],
    usersDeRegion: [],
    identifiants: [],
    itemById: {},
    disable_next: false,
    disable_prev: false,
    //Save first document in snapshot of items received
    firstInResponse: [],
    //Save last document in snapshot of items received
    lastInResponse: [],
    //Keep the array of first document of previous pages
    prev_start_at: [],
    //Maintain the count of clicks on Next Prev button
    pagination_clicked_count: 0,
    paginationSize: 10,
    field: "email",
    whereField: "active",
    whereValue: "0",
    collection: "users",
  };
};
const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_ITEM_BY_ID(state, payload) {
    state.itemById = payload;
  },
  SET_LISTE(state, payload) {
    state.users = payload;
  },
  SET_LISTE_ANIMATEURS_DE_REGIONS(state, payload) {
    state.animateursDeRegions = payload;
  },
  SET_USERS_DE_REGION(state, payload) {
    state.usersDeRegion = payload;
  },

  SET_LISTE_IDENTIFIANTS(state, payload) {
    state.identifiants = payload;
  },
  ///////////////////
  SET_DISABLE_NEXT(state, payload) {
    state.disable_next = payload;
  },
  SET_DISABLE_PREV(state, payload) {
    state.disable_prev = payload;
  },
  SET_firstInResponse(state, payload) {
    state.firstInResponse = payload;
  },
  SET_lastInResponse(state, payload) {
    state.lastInResponse = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
  SET_pagination_clicked_count(state, payload) {
    state.pagination_clicked_count = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async getAnimateurs({ commit }, regionSupervisees) {
    let self = this;
    this._vm.$vloading.show();
    let superviseurs = [];
    this._vm.$firebase
      .firestore()
      .collection("users")
      .where("active", "==", 1)
      .where("role", "==", "superviseur")
      .orderBy("displayName", "asc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          superviseurs.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        const animateursFiltres = superviseurs.filter((u) => {
          const districts = Array.isArray(u.districts) ? u.districts : [];
          return districts.some((d) =>
            _.includes(regionSupervisees, d.regions_id_region)
          );
        });
        commit("SET_LISTE_ANIMATEURS_DE_REGIONS", animateursFiltres);
        self._vm.$vloading.hide();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  },

  async GetUsersDeRegion({ commit }, region) {
    console.log("GetUsersDeRegion : ", region.id.toString());
    commit("Loading/START_BUSY_STATE", "User.store.js", { root: true });
    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("users")
      .where("districts.regions_id_region", "in", [
        region.id.toString(),
        parseInt(region.id),
      ])
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé dans Users GetUsersDeRegion");
            commit("Pending/END_PENDING_STATE", "Users GetUsersDeRegion", {
              root: true,
            });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log("elems:", elems);

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_USERS_DE_REGION", elems);
            commit("Loading/END_BUSY_STATE", "Users GetUsersDeRegion", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "Communes.store.js GetCommunesDuSuperviseurApartirDeDistricts",
            {
              root: true,
            }
          );
        }
      );
  },

  async SetItemById({ commit }, id) {
    commit("Loading/START_BUSY_STATE", "User.store.js", { root: true });
    var docRef = await this._vm.$firebase
      .firestore()
      .collection("users")
      .doc(id);

    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          //console.log("Document data:", doc.data());

          let data = [];
          data.push({
            ...doc.data(),
            id: doc.id,
          });
          commit("SET_ITEM_BY_ID", data);
          commit("Loading/END_BUSY_STATE", "User.store.js", { root: true });
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  },
  async getAllUsers({ commit }) {
    commit("Loading/START_BUSY_STATE", "users.store.js", { root: true });
    commit("SET_LISTE", []);
    const users = [];

    // ici Commence les requetes
    const GetAllUsers = await this._vm.$firebase
      .functions()
      .httpsCallable("GetAllUsers");
    GetAllUsers({ offset: 3, NextpageToKen: this.NextpageToKen }).then(
      (result) => {
        const dataItems = result.data.users;
        dataItems.forEach((item) => {
          users.push(item);
        });
        commit("Loading/END_BUSY_STATE", "users.store.js", { root: true });
        //console.log(result.data);
        //this.NextpageToKen = result.data.NextpageToKen;
      }
    );

    //Prennent fin les requestes
    commit("SET_LISTE", users);
  },

  async getAll({ commit, dispatch }) {
    // start requête
    commit("SET_LISTE_IDENTIFIANTS", []);
    commit("Loading/START_BUSY_STATE", "Users getAll", { root: true });

    let self = this;
    let elems = [];

    await this._vm.$firebase
      .firestore()
      .collection(this.state.Users.collection)
      .orderBy(this.state.Users.field)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé dans Users GetAll");

            snapshot.docChanges().forEach((change) => {
              if (change.type === "added") {
                elems = [];
              }
              if (change.type === "modified") {
                elems = [];
              }
              if (change.type === "removed") {
                elems = [];
              }
            });

            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_prev_start_at", []);

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_firstInResponse", elems[0]);
            commit("SET_lastInResponse", elems[elems.length - 1]);
            commit("SET_pagination_clicked_count", 0);
            commit("SET_DISABLE_NEXT", false);
            commit("SET_DISABLE_PREV", false);

            //Push first item to use for Previous action
            let prev_start_at = [];
            prev_start_at.push(elems[0]);
            commit("SET_prev_start_at", prev_start_at);

            commit("SET_LISTE_IDENTIFIANTS", elems);
            commit("Loading/END_BUSY_STATE", "users.store.js", { root: true });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "users.store.js", { root: true });
        }
      );
  },

  async Get({ commit, dispatch }) {
    // start requête
    commit("SET_LISTE_IDENTIFIANTS", []);
    commit("Loading/START_BUSY_STATE", "Users Get", { root: true });
    let self = this;
    let elems = [];

    await this._vm.$firebase
      .firestore()
      .collection(this.state.Users.collection)
      .orderBy(this.state.Users.field)
      .limit(10)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", "null", { root: true });
          } else {
            console.log("tout est synchronisé Dans Users Get");
            commit("Pending/END_PENDING_STATE", "null", { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_prev_start_at", []);

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_firstInResponse", elems[0]);
            commit("SET_lastInResponse", elems[elems.length - 1]);
            commit("SET_pagination_clicked_count", 0);
            commit("SET_DISABLE_NEXT", false);
            commit("SET_DISABLE_PREV", false);

            //Push first item to use for Previous action
            let prev_start_at = [];
            prev_start_at.push(elems[0]);
            commit("SET_prev_start_at", prev_start_at);

            commit("SET_LISTE_IDENTIFIANTS", elems);
            commit("Loading/END_BUSY_STATE", "users.store.js", { root: true });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "users.store.js", { root: true });
        }
      );
  },

  async nextPage({ commit }) {
    let elems = [];
    let self = this;

    commit("SET_DISABLE_NEXT", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Users.collection)
      .orderBy(this.state.Users.field)
      .startAfter(this.state.Users.lastInResponse.email)
      .limit(10)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE_IDENTIFIANTS", elems);

          if (!elems.length) {
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          commit(
            "SET_pagination_clicked_count",
            self.state.Users.pagination_clicked_count++
          );
          self.state.Users.pagination_clicked_count++;
          commit("SET_DISABLE_PREV", false);
          //Push first item to use for Previous action
          let prev_start_at = this.state.Users.prev_start_at;
          prev_start_at.push(elems[0]);
          commit("SET_prev_start_at", prev_start_at);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("SET_DISABLE_NEXT", false);
        }
      );
  },

  async prevPage({ commit }) {
    let prev_start_at = this.state.Users.prev_start_at;
    if (prev_start_at.length > this.state.Users.pagination_clicked_count + 1)
      prev_start_at.splice(prev_start_at.length - 2, prev_start_at.length - 1);
    let get_prev_startAt =
      prev_start_at[this.state.Users.pagination_clicked_count - 1];
    //console.log(get_prev_startAt);
    let elems = [];
    let self = this;
    commit("SET_DISABLE_PREV", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Users.collection)
      .orderBy(this.state.Users.field)
      .startAt(get_prev_startAt.email)
      .endBefore(self.state.Users.firstInResponse.email)
      .limit(10)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE_IDENTIFIANTS", elems);

          if (!elems.length) {
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          //Maintaing page no.
          commit(
            "SET_pagination_clicked_count",
            self.state.Users.pagination_clicked_count--
          );
          self.state.Users.pagination_clicked_count--;

          //Pop not required value in array
          let prev_start_at = self.state.Users.prev_start_at;
          prev_start_at.forEach((element) => {
            if (elems[0].id == element.id) {
              element = null;
            }
          });
          commit("SET_prev_start_at", prev_start_at);

          //Enable buttons again
          commit("SET_DISABLE_PREV", false);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("SET_DISABLE_PREV", false);
        }
      );
  },
};

const getters = {
  users: (state) => {
    return state.users;
  },
  identifiants: (state) => {
    return state.identifiants;
  },
  itemById: (state) => {
    return state.itemById;
  },
  animateursDeRegions: (state) => {
    return state.animateursDeRegions;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
